var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandcrafting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#87898C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8608 16.0232L12.0474 21.8366C11.9252 21.9588 11.7801 22.0557 11.6205 22.1219C11.4608 22.188 11.2897 22.2221 11.1169 22.2221C10.7679 22.2222 10.4332 22.0836 10.1864 21.8369C9.93954 21.5901 9.80084 21.2554 9.80078 20.9064C9.80072 20.5574 9.93931 20.2227 10.1861 19.9759L16.0001 14.1625M19.7214 17.8838L22.2024 15.4029",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8915 15.7129L20.7044 14.5257C20.4718 14.2932 20.341 13.9777 20.341 13.6487V13.4354C20.3409 13.1064 20.2101 12.791 19.9775 12.5584L18.9498 11.5307C18.2521 10.8331 17.306 10.4411 16.3194 10.4409H14.1387L14.9096 11.2119C15.6073 11.9097 15.9993 12.8561 15.9994 13.8429V14.7825L17.2398 16.023H17.9667C18.2957 16.023 18.6111 16.1538 18.8437 16.3864L20.0308 17.5735",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandcrafting);
export default __webpack_public_path__ + "static/media/handcrafting.e6e9a6594fba93d6be34c76951a906d9.svg";
export { ForwardRef as ReactComponent };